import { Routes } from '@angular/router';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { ExamPageComponent } from './pages/exam-page/exam-page.component';

export const routes: Routes = [
  {
    path: '',
    component: HomePageComponent,
  },
  {
    path: 'exams/:idOrFolio',
    component: ExamPageComponent,
  },
  {
    path: '**',
    redirectTo: '',
  },
];
